import React, { useState, useEffect, useReducer } from 'react'
import { Select, Tag } from 'antd'

const { Option } = Select
const isActiveStatus = (item) => String(item?.status || '').toLowerCase() === 'active'
const CHIP_STYLE = {
  display: 'flex',
  fontSize: 14,
  borderRadius: '16px',
  background: 'rgba(7, 78, 159, 0.1)',
  fontWeight: 400,
  height: '26px',
  alignItems: 'center',
  color: '#074E9F',
}
const CHIP_CLOSE_ICON_STYLE = {
  fontWeight: 400,
  fontSize: '15px',
  color: '#344054',
}

const GenerateCompanyFunctional = (state, action) => {
  switch (action.type) {
    case 'Generate_key':
      return (action.payload || []).map((parent, idxParent) => {
        const Key_parent = `0-${idxParent}`
        const state_parent = {
          ...parent,
          key: Key_parent,
          disabled: true,
          children: null,
        }
        return state_parent
      })
    default:
      return state
  }
}
const Company = (props) => {
  const {
    setChoiceCompany,
    setChoiceOperation,
    setChoiceSubOperation,
    masterData,
    choiceCompany,
    choiceOperation,
    choiceSubOperation,
    setAccountOptions,
    form,
    setType,
    RebaseCutterFunctionally,
    setChoiceProjectGroup,
    setChoiceProjectCategory,
    setChoiceImpactType,
    defaultCompanyName,
  } = props
  const [GenerateCompany, dispatch] = useReducer(GenerateCompanyFunctional, masterData)
  const [companyAll, setCompanyAll] = useState(GenerateCompany)
  const [choice, setChoice] = useState(choiceCompany)
  let url_page = window.location.pathname
  useEffect(() => {
    if (masterData) {
      dispatch({ type: 'Generate_key', payload: masterData })
    }
  }, [masterData])

  useEffect(() => {
    setCompanyAll(GenerateCompany)
  }, [GenerateCompany])

  useEffect(() => {
    setChoiceCompany(choice)
  }, [])

  const handleSelectCompany = (val) => {
    setAccountOptions([])
    setChoiceCompany(val)
    setChoice(val)

    RebaseCutterFunctionally('from company', val, choiceOperation, choiceSubOperation)
    if (val.length === 0) {
      ;(setChoiceOperation([]),
        setChoiceSubOperation([]),
        setChoiceProjectGroup([]),
        setChoiceProjectCategory([]),
        setChoiceImpactType([]),
        form.setFieldsValue({ radio_choice: 1, user_select: [] }))
      setType(1)
    }
  }

  const defaultCompanyNames = String(defaultCompanyName || '')
    .split(',')
    .map((item) => item.trim())
    .filter((item) => item)

  const defaultCompanyNameById = (choice || []).reduce((result, companyId, index) => {
    const companyName = defaultCompanyNames[index]

    if (companyName) {
      result[String(companyId)] = companyName
    }

    return result
  }, {})

  const companyNameById = (companyAll || []).reduce((result, item) => {
    result[String(item.company_id)] = item.title
    return result
  }, {})

  const getCompanyLabel = (value, fallbackLabel) => {
    const key = String(value)
    return companyNameById[key] || defaultCompanyNameById[key] || fallbackLabel || value
  }

  const activeCompanyOptions = (companyAll || []).filter((item) => isActiveStatus(item))

  return !url_page.includes('/management/powerbi') ? (
    <Select
      mode="multiple"
      size="large"
      style={{ width: '100%' }}
      defaultValue={choice}
      placeholder="Select Business"
      onChange={handleSelectCompany}
      maxTagCount={choice?.length > 1 ? 0 : 1}
      maxTagPlaceholder={(event) => {
        const first = event?.[0]
        return getCompanyLabel(first?.value, first?.label)
      }}
      tagRender={(event) => {
        const { label, value, closable, onClose } = event
        const displayLabel = getCompanyLabel(value, label)
        if (choice?.length > 1) {
          return (
            <Tag
              closable={closable}
              onClose={onClose}
              closeIcon={<span style={CHIP_CLOSE_ICON_STYLE}>x</span>}
              onMouseDown={(e) => e.preventDefault()}
              style={CHIP_STYLE}
            >
              {'Multi select business'}
            </Tag>
          )
        }
        return (
          <Tag
            closable={closable}
            onClose={onClose}
            closeIcon={<span style={CHIP_CLOSE_ICON_STYLE}>x</span>}
            onMouseDown={(e) => e.preventDefault()}
            style={CHIP_STYLE}
          >
            {displayLabel}
          </Tag>
        )
      }}
    >
      {activeCompanyOptions.map((item) => (
        <Option value={item.company_id} name={item.title}>
          {item.title}
        </Option>
      ))}
    </Select>
  ) : (
    <Select
      mode="multiple"
      size="large"
      style={{ width: '100%' }}
      defaultValue={choice}
      placeholder="Select Business"
      onChange={handleSelectCompany}
      maxTagCount={choice?.length > 1 ? 0 : 1}
      maxTagPlaceholder={(event) => {
        const first = event?.[0]
        return getCompanyLabel(first?.value, first?.label)
      }}
      tagRender={(event) => {
        const { label, value, closable, onClose } = event
        const displayLabel = getCompanyLabel(value, label)
        if (choice?.length > 1) {
          return (
            <Tag
              closable={closable}
              onClose={onClose}
              closeIcon={<span style={CHIP_CLOSE_ICON_STYLE}>x</span>}
              onMouseDown={(e) => e.preventDefault()}
              style={CHIP_STYLE}
            >
              {'Multi select business'}
            </Tag>
          )
        }
        return (
          <Tag
            closable={closable}
            onClose={onClose}
            closeIcon={<span style={CHIP_CLOSE_ICON_STYLE}>x</span>}
            onMouseDown={(e) => e.preventDefault()}
            style={CHIP_STYLE}
          >
            {displayLabel}
          </Tag>
        )
      }}
    >
      {activeCompanyOptions.map((item) => (
        <Option value={item.company_id} name={item.title}>
          {item.title}
        </Option>
      ))}
    </Select>
  )
}
export default Company
